import styled from "@emotion/styled";
import { Grid } from "@mui/material";

export const CommentContainer = styled(Grid)({
  marginBottom: "16px",
});
